import { FunctionComponent } from 'react';
import classNames from 'classnames';
import styles from './TiledList.module.scss';

type ListItem = {
  title: string;
  text: string | React.ReactElement;
  illustration: React.ReactElement;
};

interface TiledListProps {
  title: string;
  list: ListItem[];
}

const TiledList: FunctionComponent<TiledListProps> = ({ title, list }) => {
  return (
    <section className={styles['section']}>
      <div className={styles['content']}>
        <p className={classNames(styles['title'], 'text text--h3')}>{title}</p>

        <ul className={styles['list']}>
          {list.map((item, i) => (
            <li className={classNames(styles['list__item'], 'tile tile--padding-32px')} key={i}>
              <div className={styles['list__item__left']}>
                <p className={classNames(styles['text-1'], 'text text--body-1 text--bold')}>{item.title}</p>

                <p className={classNames(styles['text-2'], 'text text--body-3')}>{item.text}</p>
              </div>
              <div className={styles['list__item__right']}>{item.illustration}</div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default TiledList;
